import { FormState, FormReducerMapObject } from "redux-form";
import { Action, isType } from "typescript-fsa";

import { loginSuccess, usersStoreSuccess, logout } from "@auth/actions";

const loginReducer = (state: FormState, action: Action<any>) => {
    // Clear the form on success.
    if (isType(action, loginSuccess)) {
        return undefined;
    }

    return state;
};

const userFormReducer = (state: FormState, action: Action<any>) => {
    // Clear the form on success or logout.
    if (isType(action, usersStoreSuccess) || isType(action, logout)) {
        return undefined;
    }

    return state;
};

export const reducers = {
    "login": loginReducer,
    "user-form": userFormReducer,
} as FormReducerMapObject;
